import { useCallback, useRef } from 'react';
import { CircularProgress, makeStyles, Table, TableContainer } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  table: ({ headPadding }) => ({
    position: 'relative',
    height: '100%',
    '& .MuiTableCell-root': {
      border: 'none',
      fontSize: '1rem',
      fontWeight: '500',
      lineHeight: '1.675rem',
      color: '#2e4469',
      padding: '0 1rem ',
    },
    '& .MuiTableHead-root': {
      position: 'sticky',
      top: '-0.1rem !important',
      left: '0',
      zIndex: '10',
      whiteSpace: 'nowrap',
      '& .MuiTableRow-root': {
        backgroundColor: '#fff',
      },
      '& .MuiTableCell-root': {
        fontWeight: 'bold',
        color: '#538fff',
        padding: headPadding,
        backgroundColor: '#fff',
        fontSize: '0.875rem',
        fontFamily: 'NotoSans-Bold',
        textTransform: 'uppercase',
      },
    },
    '& .MuiTableBody-root': {
      '& .MuiTableCell-root': {
        padding: '0.875rem 1.2rem',
        fontFamily: 'NotoSans-Medium',
        borderBottom: '1px solid #E6E8E9',
      },
    },
  }),
  tableMultCell: {
    borderBottom: 'none !important',
  },
  loading: {
    display: 'flex',
    position: 'absolute',
    top: '65%',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
  },
}));

const TableUI = ({
  containerClassName,
  tableClassName,
  turnPages = () => {},
  loading = false,
  headPadding = '1rem',
  children,
}) => {
  const classes = useStyles({ headPadding });
  const tableRef = useRef();

  const scrollHandler = useCallback(() => {
    if (tableRef) {
      const { scrollTop, clientHeight, scrollHeight } = tableRef.current;

      if (scrollTop + clientHeight + 1 >= scrollHeight && !loading) {
        turnPages();
      }
    }
  }, [turnPages, loading]);

  return (
    <TableContainer className={containerClassName} ref={tableRef} onScroll={scrollHandler}>
      <Table className={tableClassName ?? classes.table} aria-label="simple table">
        {children}
      </Table>
      {loading && (
        <div className={classes.loading}>
          <CircularProgress color="primary" />
        </div>
      )}
    </TableContainer>
  );
};

export default TableUI;
